import { Qualification } from '@/graphql/types/graphql';
import { defineStore } from 'pinia';

export interface QualificationsState {
    qualifications: Qualification[];
    filtered: string[];
    loading: boolean;
}

export const useQualificationsStore = defineStore('qualifications', {
    state: (): QualificationsState => {
        return {
            qualifications: [],
            filtered: [],
            loading: false,
        };
    },
    actions: {
        filter(searchText: string) {
            this.filtered = this.qualifications
                .map((qualification) => {
                    return qualification.des;
                })
                .filter((des) => {
                    return (
                        (des || '')
                            .toLowerCase()
                            .indexOf((searchText || '').toLowerCase()) > -1
                    );
                });
        },
        resetFiltered() {
            this.filtered = [];
        },
    },
});
